<div class="content-container">
	<section class="data-table taxes">
		<header class="data-table__header">
			<h1 class="page-heading">
				<svg width="40" height="40" viewBox="0 0 40 40">
					<path d="M8.683 6.042h12.782a.797.797 0 0 0 .794-.799.797.797 0 0 0-.794-.799H8.683a.797.797 0 0 0-.794.8c0 .44.356.798.794.798M22.26 10.243a.797.797 0 0 0-.795-.799H8.683a.797.797 0 0 0-.794.8c0 .44.355.798.794.798h12.782a.797.797 0 0 0 .794-.799"/>
					<path d="M28.571 37.997c-5.32 0-9.647-4.175-9.647-9.306 0-5.132 4.328-9.307 9.647-9.307 5.32 0 9.648 4.175 9.648 9.307 0 5.131-4.328 9.306-9.648 9.306zM3.123 32.221c-.35 0-.646-.272-.646-.595V13.633c0-.322.296-.595.646-.595h9.389c.35 0 .646.273.646.595v.4c0 1.21 1.002 2.194 2.234 2.194h12.462c.35 0 .646.272.646.594v.967c-6.162.037-11.164 4.913-11.164 10.903 0 1.235.215 2.422.607 3.53H3.123zM5.778 2.042H25.2V14.63h-9.808c-.35 0-.646-.273-.646-.595v-.4c0-1.21-1.002-2.194-2.234-2.194H5.778V2.042zm24.31 15.846v-1.067c0-1.209-1.002-2.192-2.234-2.192h-1.066V1.243a.797.797 0 0 0-.794-.799H4.984a.797.797 0 0 0-.795.8V11.44H3.123c-1.232 0-2.234.984-2.234 2.193v17.993c0 1.21 1.002 2.193 2.234 2.193H18.66c1.894 3.434 5.626 5.776 9.912 5.776 6.196 0 11.236-4.891 11.236-10.904 0-5.514-4.238-10.081-9.718-10.803z"/>
					<path d="M28.94 27.963c-1.608-.643-2.293-1.109-2.293-2.041 0-.717.536-1.54 1.96-1.54 1.185 0 1.944.393 2.333.609l.463-1.182c-.538-.305-1.295-.59-2.406-.626v-1.739H27.85v1.81c-1.701.269-2.794 1.397-2.794 2.883 0 1.558 1.166 2.382 3.054 3.098 1.37.537 2.09 1.146 2.09 2.131 0 1.022-.887 1.755-2.202 1.755a5.052 5.052 0 0 1-2.664-.77l-.444 1.2c.647.448 1.758.77 2.83.788v1.81h1.167v-1.865c1.906-.302 2.923-1.629 2.923-3.043 0-1.594-.962-2.525-2.868-3.278"/>
				</svg>
				<ng-container i18n="@@taxes">Taxes</ng-container>
			</h1><!-- data-table__heading -->
			<div class="payment-info">
				<div class="payment-item">
					<div class="payAmount">
						<div class="amountSar" [innerHtml]="userInfo?.currency_symbol"></div>
						<div class="amountNum">{{ all_input  }}</div>
					</div>
					<small i18n="@@expenses.all_input_tax">All Input Tax</small> 
				</div>

				<div class="payment-item">
					<div class="payAmount">
						<div class="amountSar" [innerHtml]="userInfo?.currency_symbol"></div>
						<div class="amountNum">{{ all_output  }}</div>
					</div>
					<small i18n="@@expenses.all_output_tax">All Output Tax</small>
				</div>

				<!-- <div class="payment-item">
					<div class="payAmount">
						<div class="amountNum">{{ all_input - all_output  }}</div>
						<div class="amountSar">{{ userInfo?.currency_code }}</div>
					</div>
					<small i18n="@@expenses.tax_due">Tax Due</small>
				</div> -->
			</div><!-- end payment-info -->
		</header><!-- end billing-header -->
		<!-- end billing-header -->
		<div class="data-table__wrap">
			<header class="data-table__create-section">
				<div class="search-field">
					<div class="search-icon">
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19">
							<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="1.5" transform="translate(1 1)">
								<circle cx="7" cy="7" r="7"/>
								<path stroke-linecap="square" d="M13.5 12.5L18 17"/>
							</g>
						</svg>
					</div>
					<input type="text" name="search" i18n-placeholder="@@input.search_here" placeholder="Type Search Here" (keyup)="searchTaxes($event.target.value)" #searchInput>
				</div>
				<div class="create-download">
					<!-- <a href="javascript:void(0);" (click)="openAddTaxModal()" id="tax-details" data-toggle="modal" data-target="#taxdetails" class="tu-btn pink add-button">                                            
						<svg width="14" height="14" viewBox="0 0 14 14">
							<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
								<path d="M1 7h12M7 1v12"/>
							</g>
						</svg>
						<span i18n="@@expenses.record_new_taxable_expense">Record new taxable expense</span>
					</a> -->
					<a href="javascript:void(0);" class="downloadXl" (click)="exportXls()">
						<svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25">
							<g fill="#0CC5D1" fill-rule="evenodd">
								<path d="M24.375 19.458h-9.75v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438V8.108h2.438a.812.812 0 1 0 0-1.622h-2.438V4.864h9.75v14.594zM13 22.534L1.625 20.407V3.916L13 1.789v20.745zM25.188 3.243H14.624V.811a.808.808 0 0 0-.962-.796l-13 2.432A.809.809 0 0 0 0 3.243V21.08c0 .389.278.724.663.796l13 2.432a.813.813 0 0 0 .962-.796V21.08h10.563a.812.812 0 0 0 .812-.811V4.054a.812.812 0 0 0-.813-.811z"/>
								<path d="M20.129 8.387h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 11.892h1.677a.839.839 0 0 0 0-1.678H20.13a.839.839 0 0 0 0 1.678M20.129 14.677h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 17.463h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M7.953 12.351l2.681-3.447a.838.838 0 1 0-1.323-1.032l-2.483 3.193-2.092-2.391a.838.838 0 1 0-1.263 1.104l2.306 2.636-2.338 3.007a.84.84 0 0 0 .663 1.353c.248 0 .496-.11.66-.322l2.14-2.752 2.439 2.787a.836.836 0 0 0 1.184.08.837.837 0 0 0 .079-1.183L7.953 12.35z"/>
							</g>
						</svg>
						<span i18n="@@common.download_xls">download .xls</span>
					</a>
				</div>
			</header>
			<div class="data-table__filter">
				<div class="top-filter">
					<div class="left-section">
						<span class="show-text" i18n="@@common.show">Show</span>
						<div class="select-pages">
							<select nice-select (change)="switchTab($event.target.value)" id="tab-links-select">
								<option [value]="'input-tab'" [selected]="activeTab == 'input-tab'">
									<ng-container i18n="@@expenses.all_input_tax"> All Input Tax </ng-container>({{ inputTaxCount }})
								</option>
								<option [value]="'output-tab'" [selected]="activeTab == 'output-tab'">
									<ng-container i18n="@@expenses.all_output_tax"> All Output Tax </ng-container>({{ outputTaxCount }})
								</option>
							</select>
							<ul class="nav nav-pills" id="pills-tab" role="tablist">
								<li class="nav-item">
									<a class="nav-link active" id="pills-all-pill" data-toggle="pill" href="javascript:void(0);" role="tab"
										aria-controls="pills-home" (click)="switchTab('input-tab')" [class.active]="activeTab == 'input-tab'"
										aria-selected="true">
										<ng-container i18n="@@expenses.all_input_tax"> All Input Tax </ng-container>({{ inputTaxCount }})
									</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" id="pills-received-pill" data-toggle="pill" href="javascript:void(0);" role="tab"
										aria-controls="pills-profile" (click)="switchTab('output-tab')" [class.active]="activeTab == 'output-tab'"
										aria-selected="false">
										<ng-container i18n="@@expenses.all_output_tax"> All Output Tax </ng-container>({{ outputTaxCount }})
									</a>
								</li>
							</ul>
						</div>
					</div>
					<div class="right-section">
						<a href="javascript:void(0);" class="filters_block_btn filters_options" (click)="toggleFilter()">
							<svg _ngcontent-aii-c108="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="static"><path _ngcontent-aii-c108="" d="M6 12H18M3 6H21M9 18H15" stroke="#0A0A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
							<span i18n="@@common.filters">Filters</span>
						</a>
					</div>
				</div>
				<div class="body-filter" [class.show]="isFilter">
					<fieldset class="date sl">
						<label i18n="@@common.from_date">From Date</label>
						<div class="date-input-wrap">
							<input type="text" date-dropper [(ngModel)]="fromDate" (onDatePicked)="filterByDate()" data-dd-init-set="false" i18n-placeholder="@@common.from_date"  placeholder="From Date" class="date-input" data-dd-format="d/m/Y" data-dd-roundtrip="taxes-date-range" />
						</div>
					</fieldset>
					<fieldset class="date sl">
						<label i18n="@@common.to_date">To Date</label>
						<div class="date-input-wrap">
							<input type="text" date-dropper [(ngModel)]="toDate" (onDatePicked)="filterByDate()" data-dd-init-set="false" i18n-placeholder="@@common.to_date" placeholder="To Date" class="date-input" data-dd-format="d/m/Y" data-dd-roundtrip="taxes-date-range" />
						</div>
					</fieldset >
					<fieldset class="md">
						<label i18n="@@common.status">Status</label>
						<select nice-select class="nice-select" [(ngModel)]="toStatus" (change)="filterTaxes()">
							<option i18n="@@common.select_month" value="">Select Month</option>
							<option i18n="@@common.monthly" value="monthly">Monthly</option>
							<option i18n="@@common.quarterly" value="quarterly">Quarterly</option>
							<option i18n="@@common.yearly" value="yearly">Yearly</option>
						</select>
					</fieldset>
					<fieldset class="md">
						<label i18n="@@common.minimum_amount">Minimum amount</label>
						<div class="tag-input">
							<input type="text" [(ngModel)]="minAmount" (keyup)="filterByAmount()" placeholder="100"/>
							<span [innerHtml]="userInfo?.currency_symbol"></span>
						</div>
					</fieldset>
					<fieldset class="md">
						<label i18n="@@common.maximum_amount">Maximum amount</label>
						<div class="tag-input">
							<input type="text" [(ngModel)]="maxAmount" (keyup)="filterByAmount()" placeholder="10,000"/>
							<span [innerHtml]="userInfo?.currency_symbol"></span>
						</div>
					</fieldset>
					<fieldset class="filters_expanded_bottom w-auto">
						<button class="clear_allfilters py-4" (click)="clearAllFilter()">
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
								<path d="M13.3333 4.99984V4.33317C13.3333 3.39975 13.3333 2.93304 13.1517 2.57652C12.9919 2.26292 12.7369 2.00795 12.4233 1.84816C12.0668 1.6665 11.6001 1.6665 10.6667 1.6665H9.33333C8.39991 1.6665 7.9332 1.6665 7.57668 1.84816C7.26308 2.00795 7.00811 2.26292 6.84832 2.57652C6.66667 2.93304 6.66667 3.39975 6.66667 4.33317V4.99984M2.5 4.99984H17.5M15.8333 4.99984V14.3332C15.8333 15.7333 15.8333 16.4334 15.5608 16.9681C15.3212 17.4386 14.9387 17.821 14.4683 18.0607C13.9335 18.3332 13.2335 18.3332 11.8333 18.3332H8.16667C6.76654 18.3332 6.06647 18.3332 5.53169 18.0607C5.06129 17.821 4.67883 17.4386 4.43915 16.9681C4.16667 16.4334 4.16667 15.7333 4.16667 14.3332V4.99984" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
							Clear all
						</button>
					</fieldset>
				</div>
			</div>

			<!-- <header class="data-table__controls">
				<div class="select-date-from">
					<select nice-select (change)="switchTab($event.target.value)" class="select-link" id="tab-links-select">
						<option [value]="'input-tab'" [selected]="activeTab == 'input-tab'"><ng-container i18n="@@expenses.all_input_tax"> All Input Tax </ng-container>({{ inputTaxCount }})</option>
						<option [value]="'output-tab'" [selected]="activeTab == 'output-tab'"><ng-container i18n="@@expenses.all_output_tax"> All Output Tax </ng-container>({{ outputTaxCount }})</option>
					</select>

					<ul class="nav nav-pills" id="pills-tab" role="tablist">
						<li class="nav-item">
							<a class="nav-link active" id="pills-all-pill" data-toggle="pill" href="javascript:void(0);" role="tab"
								aria-controls="pills-home" (click)="switchTab('input-tab')" [class.active]="activeTab == 'input-tab'"
								aria-selected="true">
								<ng-container i18n="@@expenses.all_input_tax"> All Input Tax </ng-container>({{ inputTaxCount }})
							</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="pills-received-pill" data-toggle="pill" href="javascript:void(0);" role="tab"
								aria-controls="pills-profile" (click)="switchTab('output-tab')" [class.active]="activeTab == 'output-tab'"
								aria-selected="false">
								<ng-container i18n="@@expenses.all_output_tax"> All Output Tax </ng-container>({{ outputTaxCount }})
							</a>
						</li>
					</ul>
					
					<div class="date-from">
						<div class="date-input-wrap">
							<input type="text" date-dropper [(ngModel)]="fromDate" (onDatePicked)="filterByDate()" data-dd-init-set="false" i18n-placeholder="@@ts.from_date"  placeholder="From Date" class="date-input" data-dd-format="d/m/Y" data-dd-roundtrip="taxes-date-range" />
						</div>

						<div class="date-input-wrap">
							<input type="text" date-dropper [(ngModel)]="toDate" (onDatePicked)="filterByDate()" data-dd-init-set="false" i18n-placeholder="@@ts.to_date" placeholder="To Date" class="date-input" data-dd-format="d/m/Y" data-dd-roundtrip="taxes-date-range" />
						</div>
					</div>

					<button (click)="resetDateFilters()" class="tu-btn pink clear_btn" i18n="@@common.clear">Clear</button>
				</div>

				<div class="data-table__btn-wrap tax-expan">
					<div class="btn-row">
						<a href="javascript:void(0);" (click)="openAddTaxModal()" id="tax-details" data-toggle="modal"
							data-target="#taxdetails" class="tu-btn-circular pink">
							<svg width="14" height="14" viewBox="0 0 14 14">
								<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
									<path d="M1 7h12M7 1v12" />
								</g>
							</svg>
						</a>

						<form class="data-table__search" [class.open]="isSearch" [hidden]="activeTab == 'create-invoice'">
							<input type="text" name="data-table__search--input" i18n-placeholder="@@input.search_here" placeholder="Type Search Here"
								(keyup)="searchTaxes($event.target.value)" #searchInput/>

							<a href="javascript:void(0);" id="search-open" (click)="toggleSearch()">
								<svg width="20" height="19" viewBox="0 0 20 19">
									<g class="svg-stroke" fill="none" fill-rule="evenodd" stroke-width="1.5" transform="translate(1 1)">
										<circle cx="7" cy="7" r="7" />
										<path stroke-linecap="square" d="M13.5 12.5L18 17" />
									</g>
								</svg>
							</a>
							<svg id="search-close" width="15" height="15" class="close-icon" version="1.1" x="0px" y="0px"
								viewBox="0 0 14 14" style="enable-background:new 0 0 14 14;" xml:space="preserve"
								(click)="toggleSearch()">
								<path class="svg-stroke" fill="none" stroke-width="2" stroke-linecap="square"
									d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5" />
							</svg>
						</form>
					</div>

					<div class="taxes-type">
						<select nice-select (change)="filterTaxes($event.target.value)">
							<option i18n="@@common.select_month" value="">Select Month</option>
							<option i18n="@@common.monthly" value="monthly">Monthly</option>
							<option i18n="@@common.quarterly" value="quarterly">Quarterly</option>
							<option i18n="@@common.yearly" value="yearly">Yearly</option>
						</select>
					</div>

					<a href="javascript:void(0);" class="xl-download" (click)="exportXls()">
						<svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25">
							<g fill="#0CC5D1" fill-rule="evenodd">
								<path
									d="M24.375 19.458h-9.75v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438V8.108h2.438a.812.812 0 1 0 0-1.622h-2.438V4.864h9.75v14.594zM13 22.534L1.625 20.407V3.916L13 1.789v20.745zM25.188 3.243H14.624V.811a.808.808 0 0 0-.962-.796l-13 2.432A.809.809 0 0 0 0 3.243V21.08c0 .389.278.724.663.796l13 2.432a.813.813 0 0 0 .962-.796V21.08h10.563a.812.812 0 0 0 .812-.811V4.054a.812.812 0 0 0-.813-.811z" />
								<path
									d="M20.129 8.387h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 11.892h1.677a.839.839 0 0 0 0-1.678H20.13a.839.839 0 0 0 0 1.678M20.129 14.677h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 17.463h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M7.953 12.351l2.681-3.447a.838.838 0 1 0-1.323-1.032l-2.483 3.193-2.092-2.391a.838.838 0 1 0-1.263 1.104l2.306 2.636-2.338 3.007a.84.84 0 0 0 .663 1.353c.248 0 .496-.11.66-.322l2.14-2.752 2.439 2.787a.836.836 0 0 0 1.184.08.837.837 0 0 0 .079-1.183L7.953 12.35z" />
							</g>
						</svg>
						<span>download.xls</span>
					</a>

				</div>

			</header> -->
			<!-- end header -->

			<div class="tab-content data-table__tab-content" id="pills-tabContent">

				<div class="tab-pane fade" id="pills-view" role="tabpanel" aria-labelledby="pills-view-tab"
					[ngClass]="{'active show': activeTab == 'input-tab'}">
					<all-input-table 
						class="w-100"
						(onLoad)="onLoadInputTaxes($event)" 
						[userInfo]="userInfo"
						(perPageItems)="onChangePerPageItems($event)"
						#allInputTableRef
					></all-input-table>
				</div>
				<!-- end #projectTaxes -->

				<div class="tab-pane fade" id="pills-received" role="tabpanel" aria-labelledby="pills-received-tab" [ngClass]="{'active show': activeTab == 'output-tab'}">
					<teemapp-table 
						class="table-scroll"
						[name]="'output-taxes'" 
						[tableClass]="'output-tax'"
						[tableSchema]="taxesTable"
						[selectable]="false"
						(onLoad)="onLoadOutputTaxes($event)"
						#taxesTableRef
					>
					</teemapp-table>
				</div>
				<!-- end #otherExpenses -->
			</div>
		</div>
		<!-- end data-table__wrap -->
	</section>
	<!-- end data-table -->
</div>
<!-- end content-container -->